<template>
  <div class="keywordCard">
    <div class="left">
      <div class="title">已保存的关键词</div>
      <div class="leftBox">
        <div class="btnBar">
          <span class="total">共{{this.savedKeywordList.length}}条</span>
          <div class="btn">
            <el-button type="text" @click="edit">{{ readonly ? '编辑' : '完成编辑' }}</el-button>
            <el-button type="text" @click="copy">复制</el-button>
            <el-button type="text" @click="fillTo" v-show="aiModel===2">填充到方案</el-button>
            <!--            <el-button type="text" @click="addTo">添加到账户</el-button>-->
          </div>
        </div>
        <div class="info">
          <el-input
              type="textarea"
              :rows="25"
              placeholder=""
              resize="none"
              :readonly="readonly"
              v-model="textarea">
          </el-input>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="title">关键词生成结果
        <div>
          <el-button type="primary" size="mini" @click="clearKeywords">清空</el-button>
          <el-button type="primary" size="mini" @click="$emit('remake')" :disabled="keywordLoading">
            {{ keywordLoading ? '正在生成' : '重新生成' }}
          </el-button>
          <el-button type="primary" size="mini" :disabled="keywordLoading" @click="dialogVisible=true">AI修改
          </el-button>
        </div>
      </div>
      <div class="rightBox">
        <div class="topBox">
          <div class="topTitle">
            <span>规划师关键词提示</span>
            <el-button type="text" @click="plannerKeyword" :disabled="!nextPageToken">换一批</el-button>
          </div>
          <div class="content">
            <el-tabs>
              <el-tab-pane v-for="(item) in googleKeys" :name="item.content"  :key="item.id">
                <span slot="label">
                  <el-button size="mini" icon="el-icon-plus" @click="addGoogleKey(item)" circle></el-button>
                  {{ item.content }}</span>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="cardBox" v-loading="keywordLoading" element-loading-text="AI生成中...">
          <div class="card" v-for="(item, index) in keywordList" :key="item.id">
            <div class="cardLeft">
              <div class="ch">{{ item.content }}</div>
              <div class="en">{{ item.zhContent }}</div>
              <div class="others">
                <span>竞争：{{ item.compete || '-.-' }}</span>
                <span>搜索： {{ item.searchNum || '-.-' }}</span>
                <span>均价： {{ item.averagePrice || '-.-' }}</span>
              </div>
              <div class="control">
                <el-link :underline="false" icon="el-icon-document" @click="save(item)">保存</el-link>
                <el-link :underline="false" icon="el-icon-delete" @click="$emit('del',item)">删除</el-link>
                <el-link :underline="false" icon="el-icon-search" @click="search(item)">在Google图片中搜索</el-link>
              </div>
            </div>
            <div class="cardRight">
              <el-button v-show="item.imageList.length<1" type="primary" icon="el-icon-search" @click="$emit('getImg',index)">查看Google图片</el-button>
              <el-avatar v-for="(img, index) in item.imageList" :key="index" shape="square" :size="76" fit="fill"
                         :src="img"></el-avatar>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        title="AI修改"
        :visible.sync="dialogVisible"
        width="30%"
        :modal="false"
    >
      <el-row>
        <el-col>
          <el-input placeholder="请输入内容" v-model="modifyText">
            <template slot="append">
              <el-button icon="el-icon-s-promotion" @click="aiModify(modifyText)"></el-button>
            </template>
          </el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-button type="text" @click="aiModify('再写10条')">再写10条</el-button>
          <el-button type="text" @click="aiModify('拓长尾词')">拓长尾词</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import {mapState} from "vuex";
import sem from "@/backend/services/sem/sem";

export default {
  name: 'keywordCard',
  props: {
    keywordLoading: {
      type: Boolean,
      default: false
    },
    keywordList: {
      type: Array,
      default: () => []
    },
    programmeDetailId: String
  },
  data() {
    return {
      textarea: '',
      readonly: true,
      googleKeys: [
        // {
        //   "id": "1800961203036733440",
        //   "content": "B2B serum testing kits",
        //   "zhContent": "B2B血清检测套件",
        //   "saveFlag": null,
        //   "compete": null,
        //   "searchNum": null,
        //   "averagePrice": null,
        //   "images": null,
        //   "imageList": []
        // }
      ],
      savedKeywordList: [],
      dialogVisible: false,
      modifyText: '',
      nextPageToken: ''
    }
  },
  computed: {
    ...mapState({
      aiModel: state => state.aiAds.aiModel,
      currentInfo: state => state.aiAds.currentInfo
    })
  },
  mounted() {
    this.getSavedKeyword();
    this.plannerKeyword();
  },
  watch:{
    programmeDetailId: {
      handler(val) {
        if (val) {
          this.getSavedKeyword()
        }
      }
    }
  },
  methods: {
    // 规划师关键词添加到下面关键词列表
    addGoogleKey(item){
      this.$emit('addGoogleKey', item)
      // 添加了后就删掉
      this.googleKeys=this.googleKeys.filter(key=>{
        return key.id!==item.id
      })
    },
    // AI修改
    aiModify(text) {
      if (text) {
        this.dialogVisible = false;
        this.modifyText = '';
        this.$emit('modify', text)
      } else {
        this.$message.error('不能发送空消息！')
      }
    },
    // 清空方法
    clearKeywords() {
      this.$confirm('清空已生成的数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('clear')
        this.emptyKeyword();
      })
    },
    // 清空关键词接口
    async emptyKeyword() {
      let param = {};
      if (this.aiModel === 1) {
        param = {
          programmeDetailId: this.programmeDetailId,
          programmeId: this.currentInfo.programmeId,
        }
      } else if (this.aiModel === 2) {
        param = {
          programmeDetailId: this.programmeDetailId,
          programmeId: this.currentInfo.programmeId,
          serviceId: this.currentInfo.serviceId
        }
      }
      let res = await sem.emptyKeyword(param);
      if (res.data === 'success') {
        this.$message.success('已清空');
      }
    },
    // 获取已保存的关键词信息
    async getSavedKeyword() {
      let res = await sem.getSavedKeyword(this.programmeDetailId)
      this.savedKeywordList = res.data.keywordList || [];
      this.textarea = this.savedKeywordList.join('\n')
    },
    // 添加关键词方法
    save(item) {
      if (this.savedKeywordList.includes(item.content)) {
        this.$message.error('该关键词已存在！');
      } else {
        this.savedKeywordList.push(item.content);
        this.addKeyword();
      }
    },
    // 保存关键词接口
    async addKeyword() {
      let param = {
        saveType: 1,
        programmeDetailId: this.programmeDetailId,
        programmeId: this.currentInfo.programmeId,
        keywordList: this.savedKeywordList
      }
      await sem.addKeyword(param);
      await this.getSavedKeyword();
    },
    // 谷歌搜索
    search(item) {
      window.open(`https://www.google.com.hk/search?q=${item.content}&tbm=isch`)
    },
    // 左边编辑、完成编辑
    edit() {
      this.readonly = !this.readonly;
      // 完成编辑时，转换为字符串数组，去重、去掉空字符串元素
      if (this.readonly) {
        this.savedKeywordList = [...new Set(this.textarea.split('\n'))].filter(item => item !== "");
        this.addKeyword();
      }
    },
    // 左边复制
    copy() {
      // 复制文本到剪贴板
      navigator.clipboard.writeText(this.textarea)
          .then(() => {
            this.$message.success('文本已成功复制到剪贴板')
          })
          .catch((error) => {
            console.error('复制文本到剪贴板失败:', error);
            this.$message.error('复制文本到剪贴板失败')
          });
    },
    // 规划师关键词获取
    async plannerKeyword() {
      let param = {};
      param = {
        programmeId: this.currentInfo.programmeId,
        serviceId: this.currentInfo.serviceId || undefined,
        programmeDetailId: this.programmeDetailId,
        nextPageToken: this.nextPageToken||undefined
      }
      let res = await sem.plannerKeyword(param)
      this.googleKeys = res.data.keywordTempInfoVOList;
      this.nextPageToken=res.data.nextPageToken||''
    },
    fillTo() {
      this.$emit('fillTo', this.savedKeywordList)
    },
    addTo() {
      console.log('添加到账户')
    }
  }
}
</script>
<style lang="scss">
.keywordCard {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;

  .title {
    font-size: 16px;
    border-left: 5px solid #52a4f8;
    box-sizing: border-box;
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    display: flex;
    justify-content: space-between;
  }

  .left {
    width: 30%;
    height: 600px;

    .leftBox {
      width: 100%;
      height: 100%;
      border: 1px solid #999;
      border-radius: 4px;
      margin-top: 10px;
      box-sizing: border-box;
      padding: 0 10px;

      .btnBar {
        display: flex;
        justify-content: space-between;

        .total {
          line-height: 40px;
        }
      }
    }
  }

  .right {
    width: 65%;

    .rightBox {
      margin-top: 10px;

      .topBox {
        border: 1px solid #999;
        box-sizing: border-box;
        padding: 0 10px;
        border-radius: 4px;

        .topTitle {
          display: flex;
          justify-content: space-between;
          line-height: 40px;
        }

        .content {

        }
      }

      .cardBox {
        width: 100%;
        height: 494px;
        margin-top: 10px;
        border: 1px solid #999;
        border-radius: 4px;
        box-sizing: border-box;
        padding: 5px 10px;
        overflow-y: auto;

        .card {
          display: flex;
          border: 1px solid #999;
          height: 80px;
          box-sizing: border-box;
          padding: 0 10px;

          overflow: hidden;
          margin-bottom: 10px;

          &:hover .control {
            transform: translateY(-25px);
          }

          .cardLeft {
            width: 50%;
            position: relative;

            .ch, .en, .others, .control {
              height: 25px;
              line-height: 25px;
            }

            .en, .others {
              color: #999;
            }

            .others {
              span {
                margin-right: 20px;
              }
            }

            .control {
              display: flex;
              justify-content: space-between;
              align-items: center;
              background-color: #fff;
              position: absolute;
              width: 100%;
              bottom: -25px;
              transition: transform 0.3s ease;
            }
          }

          .cardRight {
            width: 50%;
            display: flex;
            justify-content: space-evenly;
            align-items: center;
          }
        }
      }
    }
  }
}
</style>